export default __webpack_public_path__ + "static/facilities-img5-b175389f3969be9ffc059e0c2d55c2a9.png";